import { Card } from 'baseui/card';
import { memo } from 'react';
import { LiveStatusConvoyDetail, LiveStatusDetail } from '../../types/liveStatus';
import { Block } from 'baseui/block';
import { StyledDivider } from 'baseui/divider';
import { CONVOY_SEPARATION } from '../../constants/liveStatus';
import ConvoyDetailCardHeader from './DetailCards/ConvoyDetailCardHeader';
import DetailCardHeader from './DetailCards/DetailCardHeader';
import DetailCardBody from './DetailCards/DetailCardBody';
import ConvoyDetailCardBody from './DetailCards/ConvoyDetailCardBody';

type Props = {
  data: LiveStatusConvoyDetail | LiveStatusDetail;
  identifier: string;
};
function LiveStatusCard({ data, identifier }: Readonly<Props>) {

  return (
    <Block>
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        {identifier === CONVOY_SEPARATION && (
          <>
            <ConvoyDetailCardHeader liveStatusConvoyDetail={data as LiveStatusConvoyDetail} />
            <StyledDivider
              $size="cell"
              style={{ marginTop: 0, marginBottom: 0 }}
            />
            <ConvoyDetailCardBody liveStatusConvoyDetail={data as LiveStatusConvoyDetail} />
          </>
        )}
        {identifier !== CONVOY_SEPARATION && (
          <>
            <DetailCardHeader liveStatusDetail={data as LiveStatusDetail} />
            <StyledDivider
              $size="cell"
              style={{ marginTop: 0, marginBottom: 0 }}
            />
            <DetailCardBody liveStatusDetail={data as LiveStatusDetail} />
          </>
        )}
      </Card>
    </Block>
  );
}

export default memo(LiveStatusCard);
